import type { UpdateReportInput } from '#shared/types';
import { api } from '#client/lib/api';
import { ENDPOINT } from '#client/lib/endpoints';

/** Saves a report's results, notes and status in one request. */
export function saveReport(reportId: number, input: UpdateReportInput): Promise<unknown> {
  return api.patch(ENDPOINT.report(reportId), input);
}
